import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

type ThemePreference = 'light' | 'dark';

const THEME_STORAGE_KEY = 'theme-preference';

const resolveTheme = (): ThemePreference => {
  const persisted = localStorage.getItem(THEME_STORAGE_KEY);

  if (persisted === 'light' || persisted === 'dark') {
    return persisted;
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

const theme = resolveTheme();
document.documentElement.classList.toggle('dark', theme === 'dark');

bootstrapApplication(AppComponent, appConfig);
